import { useQuery } from '@tanstack/react-query';

import { getReligionsTypes } from '../functions/religion';

export const useGetReligionsTypes = () =>
  useQuery({
    queryKey: ['get-religions-types'],
    queryFn: () => getReligionsTypes()
  });
